// extracted by mini-css-extract-plugin
module.exports = {"outer":"TourFocus_outer__3zgrd","isActive":"TourFocus_isActive__1yuwA","message":"TourFocus_message__5XG03"};